import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as policies from '../../policies'

export const RESOURCE = {
  payload: {
    description:
      'A single company policy document, such as the Acceptable Use Policy or a state employment supplement, within a policy area.',
    dimension: policies.RESOURCE.payload,
    level: 1,
    name: 'Policy',
    partialId: PartialId.Standard.create('policy'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
